import React, { useEffect, useRef, useState } from "react";
import Modal from "../../Components/Base/Modal";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import {
  TextInput,
  closeIcon,
  chevronBottom2,
} from "../../Components";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
  {
    transform: "rotate(90deg)",
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles("dark", {
    backgroundColor: "rgba(255, 255, 255, .05)",
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function ModalLocation(props) {
  const [expanded, setExpanded] = React.useState("panel1");
  const inputWrapper = useRef(null);
  const [list, setList] = useState([]);
  const [focus, setFocus] = useState(true);
  const [readOnly, setReadOnly] = useState(false);
  const inpRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [selCountry, setSelCounty] = useState([]);
  console.log(props.selectedLocationData.country)
  const optionClickHandler = (item) => {
    let newitem = props.selectedLocationData.country;
    newitem.push(item);
    props.setSelectedLocationData({ ...props.setSelectedLocationData, ['country']: newitem });
    closeSearch();
  };
  const saveLocation = () => {
  }
  const handleChange = (panel) => (event, newExpanded) => {
    if (panel === 'panel2') {
      props.setSelectedLocationData({ ...props.setSelectedLocationData, ['country']: [] });
    }
    setExpanded(newExpanded ? panel : false);
  };
  const initForm = {
    selCounty: [],
  };
  const [form, setForm] = useState(initForm);
  const delCountry = (label) => {
    let newCountry = [...props.selectedLocationData.country];
    let index = newCountry.indexOf(label);
    newCountry.splice(index, 1);
    props.setSelectedLocationData({ ...props.setSelectedLocationData, ['country']: newCountry });
  };
  const closeSearch = () => {
    setSearchValue("");
    setFocus(false);
    inpRef.current.value = "";
    inpRef.current.blur();
  };
  console.log(props.countries)
  useEffect(() => {
    let newList = [];
    props.countries.map(item => newList.push(item.label))
    setList(newList);
    const windowClick = ({ target }) => {
      if (!inputWrapper.current.contains(target)) closeSearch();
    };

    if (focus) window.addEventListener("click", windowClick);
    else window.removeEventListener("click", windowClick);
    return () => window.removeEventListener("click", windowClick);
  }, [focus]);

  const handlePress = (event) => {
    const inputItem = event.target;
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      event.preventDefault();
      setSelCounty(inputItem);
      return;
    }
  };
  const searchListFunc = (text) => {
    return list.filter((item) =>
      item.toUpperCase().startsWith(text.toUpperCase())
    );
  };
  const handleChangeTextInput = (event) => {
    const list = searchListFunc(event.target.value);
    setSearchValue(event.target.value);
    setList(list);
  };
  const handleClear = () => {
    props.setSelectedLocationData({ ...props.setSelectedLocationData, ['country']: [] });
  }
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="filterModal modal__camp">
        <div className="modal__assetDetail-delete perm long">
          <h4>Location</h4>
          <div className="accordion-wrapper">




            <div className="searchByLocation">Country:</div>
            <div
              className="recomForm__industry filter-country"
              ref={inputWrapper}
            >
              <TextInput
                btnClickHandler={() => setFocus(!focus)}
                optionClickHandler={optionClickHandler}
                inpRef={inpRef}
                onKeydown={handlePress}
                type="text"
                icon={chevronBottom2}
                list={form.selCounty}
                autoCompleteList={list}
                searchValue={searchValue}
                searchList={props.countries}
                onFocus={() => setFocus(true)}
                showList={focus}
                onChange={handleChangeTextInput}
                readOnly={readOnly}
              />
              <>
                {props.selectedLocationData.country.length > 0 && (
                  <div className="recomForm__industry-items">
                    {props.countries.map((item, index) => {
                      let obj = props.selectedLocationData.country.find(cat => (cat) === item.label);
                      if (obj) {
                        return (
                          <div className="recomForm__industry-item" key={item.value}>
                            {item.label}
                            {!readOnly && <div
                              className="recomForm__industry-item-icon"
                              onClick={() => delCountry(item.label)}
                            >
                              {closeIcon}
                            </div>
                            }
                          </div>
                        );
                      }
                    })
                    }
                  </div>)}
              </>
            </div>

          </div>
          <div className="breakLine">
            <div className="campaignsCreate__btns filterbuttons">
              <div class="campaignsCreate__btns-row"><button className="clearButton" onClick={handleClear}>Clear</button></div>
              <button className="button primary" onClick={() => { saveLocation(); props.handleSearch() }}>
                Save
              </button>
            </div>
          </div>

        </div>
      </div>
    </Modal>
  );
}
